export default __webpack_public_path__ + "static/media/angbao-bonus.1b068f17.webp";